import { appConfig, headerConfig, refineHeader } from "../../config";

export const contractService = {
  add_contract,
  add_product,
  add_auction,
  getContractList,
  getContractNotExecutedList,
  deleteContract,
  getContractDetails,
  getProductDetails,
  getAuctionDetails,
  update_contract,
  update_product,
  update_auction,
  clone_contract,
  clone_product_detail,
  clone_auction_detail,
  clone_contract_non_executed,
  clone_product,
  clone_auction,
  executeContract,
  uploadPhysicalContracts,
  removeChildContract,
  sendContractMail,
  getContractPoposal,
  ContractType,
};

function add_contract(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}contract/add`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function add_product(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}product/add`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function add_auction(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}auction/add`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function executeContract(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}deal/executeContract`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function uploadPhysicalContracts(postData) {
   refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerImage,
    mode: "cors",
    body: postData
  };

  return fetch(`${appConfig.api.url}contract/uploadContracts`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function update_contract(postData) {
  refineHeader();
  const requestOptions = {
    method: "PUT",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}contract/edit`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function update_product(postData) {
  refineHeader();
  const requestOptions = {
    method: "PUT",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}product/first-edit`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function update_auction(postData) {
  refineHeader();
  const requestOptions = {
    method: "PUT",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}auction/first-edit`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function clone_contract(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}contract/clone`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function clone_product_detail(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}product/clone`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function clone_auction_detail(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}auction/clone`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function clone_contract_non_executed(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}contract/clone-non-execeuted`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function clone_product(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}product/clone-product`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function clone_auction(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}auction/clone-auction`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getContractList(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}contract/list`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function getContractNotExecutedList(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}contract/nonexecuted-list`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function deleteContract(contractIdAsParams) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(
    `${appConfig.api.url}contract/delete/${contractIdAsParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function removeChildContract(contractIdAsParams) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(
    `${appConfig.api.url}contract/delete-child/${contractIdAsParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getContractDetails(contractIdParams) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(
    `${appConfig.api.url}contract/detail/${contractIdParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getProductDetails(contractIdParams) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(
    `${appConfig.api.url}product/detail/${contractIdParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getAuctionDetails(contractIdParams) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(
    `${appConfig.api.url}auction/detail/${contractIdParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getContractPoposal(contractIdParams) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(
    `${appConfig.api.url}proposal/dynamic-template-contract-proposal/${contractIdParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function sendContractMail(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}contract/mail-merchant`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}


function ContractType(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}contract/ContractType`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}



// WEBPACK FOOTER //
// ./src/app/services/API/contractService.js